import React from "react";

const ScorePlusToolbar = ({
  activeView,
  setView,
  sampleMode,
  toggleSample,
}) => {
  return (
    <div className="bg-gray-900 rounded-xl border border-gray-700 p-3">
      <div className="flex flex-wrap gap-2">
        {[
          ["dashboard", "Dashboard"],
          ["calendar", "Calendar"],
          ["analytics", "Analytics"],
          ["form", "Add"],
          ["records", "History"],
          ["subsactivitylink", "Subscription-Activity"],
          ["about", "About"],
        ].map(([key, label]) => (
          <button
            key={key}
            onClick={() => setView(key)}
            className={`
              w-fit px-3 py-1 rounded text-xs font-bold
              ${activeView === key ? "bg-cyan-500 text-black" : "bg-gray-700 text-white"}
              `}
          >
            {label}
          </button>
        ))}

        <button
          onClick={toggleSample}
          className={`w-fit px-3 py-1 rounded text-xs font-bold ${
            sampleMode ? "bg-amber-500 text-black" : "bg-emerald-600 text-white"
          }`}
        >
          {sampleMode ? "🧪 Sample Mode" : "🟢 Live Mode"}
        </button>
      </div>
    </div>
  );
};

export default ScorePlusToolbar;
